import { Image, Text, View } from "@react-pdf/renderer";

import { getZadovoljenaKontrola } from "../../../helpers/GetRecordPointClass";
import { styles } from "../../Tables";

interface TableTemperaturaHeaderProps {
  title1: string;
  value1?: number;
  title2: string;
  value2?: number;
  title3: string;
  value3?: number;
}

export const TableTemperaturaListaEvidencijaHeader: React.FC<
  TableTemperaturaHeaderProps
> = ({ title1, value1, title2, value2, title3, value3 }) => (
  <View style={styles.table}>
    {value1 && (
      <View style={styles.tableRow}>
        <View style={styles.tableColHorizontal}>
          <Text>{title1}</Text>
        </View>
        <View style={styles.tableColHorizontal}>
          <Text>
            {typeof value1 === "number"
              ? String(value1).replace(".", ",")
              : value1}
          </Text>
        </View>
      </View>
    )}
    {value2 && (
      <View style={styles.tableRow}>
        <View style={styles.tableColHorizontal}>
          <Text>{title2}</Text>
        </View>
        <View style={styles.tableColHorizontal}>
          <Text>
            {typeof value2 === "number"
              ? String(value2).replace(".", ",")
              : value2}
          </Text>
        </View>
      </View>
    )}
    {value3 && (
      <View style={styles.tableRow}>
        <View style={styles.tableColHorizontal}>
          <Text>{title3}</Text>
        </View>
        <View style={styles.tableColHorizontal}>
          <Text>
            {typeof value3 === "number"
              ? String(value3).replace(".", ",")
              : value3}
          </Text>
        </View>
      </View>
    )}
  </View>
);

export const TableRowTemperaturaEvdListaEvidencijaHeader: React.FC<{
  resocitanaTemperatura: string;
  reszadovoljenaKontrola: string;
  restackaPrimjene: string;
  resdatum: string;
  resfullname: string;
  respotpis: string;
}> = ({
  resocitanaTemperatura,
  reszadovoljenaKontrola,
  respotpis,
  restackaPrimjene,
  resdatum,
  resfullname,
}) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text>{restackaPrimjene}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{resdatum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{resfullname}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{respotpis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{resocitanaTemperatura}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{reszadovoljenaKontrola}</Text>
    </View>
  </View>
);

export const TableRowTemperaturaEvdListaEvidencija: React.FC<{
  fullname: string;
  potpis: string;
  ocitanaTemperatura: number | null;
  dozvoljenaTempMin: number | null;
  dozvoljenaTempMax: number | null;
  dozvoljenoOdstupanje: number | null;
  datum: string;
  tackaPrimjene: string;
  resda: string;
  resne: string;
}> = ({
  fullname,
  potpis,
  ocitanaTemperatura,
  datum,
  dozvoljenaTempMin,
  dozvoljenoOdstupanje,
  dozvoljenaTempMax,
  tackaPrimjene,
  resda,
  resne,
}) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{tackaPrimjene}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpis && (
        <Image style={[styles.tableCell, styles.signatureImage]} src={potpis} />
      )}
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>
        {typeof ocitanaTemperatura === "number"
          ? String(ocitanaTemperatura).replace(".", ",")
          : ocitanaTemperatura}
      </Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>
        {getZadovoljenaKontrola(
          Number(ocitanaTemperatura),
          dozvoljenaTempMin,
          dozvoljenaTempMax,
          dozvoljenoOdstupanje
        )
          ? resda
          : resne}
      </Text>
    </View>
  </View>
);
